import React from 'react';
import './Footer.module.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <p>Copyright &copy; {currentYear}. Developed by Jesse Sambo. All rights reserved.</p>
    </footer>
  );
};

export default Footer;